<template>
    <div class="app-compatibility-warning">
        <p class="mb-0">
            <span>{{ $t('_page.error.browser_incompatible') }}</span>
        </p>
    </div>
</template>

<script>
export default {
    name: 'AppCompatibilityWarning'
};
</script>
<style lang="scss" scoped>
.app-compatibility-warning {
    position: sticky;
    z-index: 5;
    top: 0;
    left: 0;
    right: 0;
    min-height: var(--v-app-compatibility-warning-height);
    background: var(--v-warning-lighten3);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.5rem;

    p {
        font-size: 0.95rem;
        color: var(--v-warning-darken3);
    }
    i {
        font-size: 1em !important;
        color: var(--v-warning-darken3);
    }
}
</style>
